export default "__VITE_ASSET__ef41164c__"